import { render } from "./ChannelGraph.vue?vue&type=template&id=49b21109&scoped=true"
import script from "./ChannelGraph.vue?vue&type=script&lang=js"
export * from "./ChannelGraph.vue?vue&type=script&lang=js"

import "./ChannelGraph.vue?vue&type=style&index=0&id=49b21109&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49b21109"]])

export default __exports__